import { useState } from 'react'

export default () => {
    const [shelTaskData, setShelfTaskData] = useState(null)

    // 记录任务
    const recordTask = e => {
        setShelfTaskData(e)
    }

    // 获取任务
    const getTask = () => {
        return shelTaskData
    }

    // 是否已记录任务
    const checkHasRecordTask = () => {
        return !!shelTaskData
    }

    return {
        recordTask,
        getTask,
        checkHasRecordTask
    }
}
